import React from "react";
import { NavDropdown } from 'react-bootstrap';
import { createBrowserRouter, RouterProvider, } from "react-router-dom";
import { IndexPage } from "./pages/IndexPage";
import { PageWelevenClock } from "./pages/PageWelevenClock";
import { PageWelevenStart } from "./pages/PageWelevenStart";
const router = createBrowserRouter([
    {
        path: "/",
        element: React.createElement(IndexPage, null),
    },
    {
        path: "/kweleven-start",
        element: React.createElement(PageWelevenStart, null)
    },
    {
        path: "/kweleven-clock",
        element: React.createElement(PageWelevenClock, null)
    }
]);
export const Application = () => {
    return React.createElement(React.StrictMode, null,
        React.createElement("div", { className: "flex flex-row m-0 p-3 bg-primary" },
            React.createElement("a", { className: "navbar-brand text-white", href: "/" }, "KWELEVEN"),
            React.createElement("div", { className: "container text-white" },
                React.createElement(NavDropdown, { title: "Products" },
                    React.createElement(NavDropdown.Item, { href: "/kweleven-start", className: "fs-7" }, "KWELEVEN Start"),
                    React.createElement(NavDropdown.Item, { href: "/kweleven-clock", className: "fs-7" }, "KWELEVEN Clock")))),
        React.createElement("div", { className: "container-fluid flex flex-column flex-grow mt-5 p-0" },
            React.createElement("div", { className: "container" },
                React.createElement(RouterProvider, { router: router }))),
        React.createElement("div", { className: "align-self-center p-3" },
            React.createElement("span", { className: "flex justify-content-center" },
                React.createElement("span", { className: "pe-2 x-small text-disabled" },
                    "\u00A9 ",
                    new Date().getFullYear()),
                React.createElement("a", { className: "pe-2 x-small text-decoration-none text-disabled", href: "https://www.kweleven.org" }, "KDE WELEVEN"),
                React.createElement("span", { className: "fs-1 middot pe-2 text-disabled" }, "\u00B7"),
                React.createElement("a", { className: "pe-2 x-small text-decoration-none text-disabled", href: "/privacy-policy" }, "Privacy Policy"),
                React.createElement("span", { className: "fs-1 middot pe-2 text-disabled" }, "\u00B7"),
                React.createElement("a", { className: "x-small text-decoration-none text-disabled", href: "/legal-notice" }, "Legal Notice"))));
};
